export default function({ state, commit, dispatch }, filter) {
    commit('startEditingFilter')

    return dispatch('post', {
        url: '/provider/' + state.id + '/filter',
        data: filter
    }, {
        root: true
    })
    .then((response) => {
        commit('finishEditingFilter')
        commit('addFilter', {id : state.id, filter: response})
		return response
    })
    .catch((error) => {
        commit('finishEditingFilter')
		throw error
    })
}
